import axios from 'axios';

function slug(name) {
  return (
    String(name || '')
      .normalize('NFKD')
      .replace(/[^A-Za-z0-9._-]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60) || 'archive'
  );
}

// Downloads an uploaded lander / offer / white page as a ZIP of its current
// files (edits made in the file editor included). Uses axios so the auth
// header goes along; the browser then saves the blob.
export async function downloadArchive(api, path, name) {
  const r = await axios.get(api + path, { responseType: 'blob' });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = slug(name) + '.zip';
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
